module.exports = __webpack_public_path__ + "static/media/map-card-close-x.9894d3f5.svg";